// src/components/HeaderImage.js
import React from 'react';
import { Box } from '@mui/material';

const HeaderImage = () => (
  <Box
    sx={{
      height: '230px',
      backgroundImage: 'url(/f07808f6-8bc1-4595-b8db-524551380a6e.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
  />
);

export default HeaderImage;
